import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Skeleton } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import * as Styles from './GreetingBanner.styles';
import { isBRServer } from '@/utils/Validators/validation';
import withErrorBoundary from '@/utils/errorBoundary';

const GreetingBanner = ({
  size, title, cta, loading, displayCreateSiteBanner,
}) => {
  const { home: homeLocale } = useLocale();
  const firstName = useSelector(state => state.summary.firstname);

  const titleHtml = title && title.replace(isBRServer ? '%nome%' : '%nombre%', firstName);

  if (loading) {
    return (
      <Styles.SkeletonWrapper data-testid="greeting-banner" size={size}>
        <Skeleton height="150px" width="450px" variant="paragraph" />
        <Skeleton height="32px" width="164px" variant="button" />
      </Styles.SkeletonWrapper>
    );
  }

  return (
    <Styles.GreetingBanner data-testid="greeting-banner" size={size}>
      <Styles.Row>
        <Styles.Column>
          <Styles.GreetingBannerTitle dangerouslySetInnerHTML={{ __html: titleHtml }} />
          <Styles.GreetingBannerSubtitle>
            {homeLocale.greetingBanner.subtitle}
          </Styles.GreetingBannerSubtitle>
        </Styles.Column>

        {displayCreateSiteBanner && (
          <Styles.Column>
            <Styles.WrapperButton>
              <Button
                label={cta.label}
                onClick={cta.onClick}
                size="large"
                testId="button"
                title={homeLocale.greetingBanner.labelButton}
                type="button"
                variant="tertiary"
                version="v2"
                width="fit-content"
              />
            </Styles.WrapperButton>
          </Styles.Column>
        )}
      </Styles.Row>
    </Styles.GreetingBanner>
  );
};
export default withErrorBoundary(GreetingBanner, 'GreetingBanner');
